<template>
  <div>
    <v-row>
      <v-col md="8" cols="12">
        <!-- ------------------------------------------------------------------------- -->
        <v-card>
          <v-tabs :background-color="$pgsHelper.uiConfig().mainColor" dark>
            <template v-for="(area, index) in areas">
              <v-tab :key="index">
                {{ area.Nombre }}
              </v-tab>
            </template>
            <template v-for="(area, index) in AreasData">
              <v-tab-item :key="index">
                <v-card flat>
                  <v-card-text>
                    
                    <floorRestaurant
                      :key="indexMapa"
                      :contenedores="getAybContenedores"
                      :editable="false"
                      :roomData="area"
                      :noClick="true"
                      :reservationView="reservations"
                      :reservationDate="reserva.fecha"
                      :reservationSelected="reserva.mesa"
                      @triggerOpenTable="triggerBokingTable"
                    />
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </template>
          </v-tabs>
        </v-card>
        <!-- ------------------------------------------------------------------------- -->
      </v-col>
      <v-col md="4" cols="12">
        <v-form ref="mesaForm">
          <v-text-field
            v-model="reserva.nombre"
            label="Nombre"
            :rules="Rules.Nombres"
            required
          ></v-text-field>
          <v-menu
            v-model="fromDateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                label="Fecha"
                prepend-icon="mdi-calendar"
                readonly
                :value="fromDateDisp"
                v-on="on"
                :rules="Rules.fecha"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="reserva.fecha"
              no-title
              @input="
                fromDateMenu = false;
                indexMapa++;
              "
              :min="today"
            ></v-date-picker>
          </v-menu>

          <!--   <v-text-field
            v-model="reserva.hora"
            v-mask="'##:##'"
            label="Hora"
            :rules="Rules.Hora"
            required
          ></v-text-field> -->

          <label for="timepicker" :style="errorMessage ? 'color: red' : ''">
            <v-icon :style="errorMessage ? 'color: red' : ''"
              >mdi-calendar-clock</v-icon
            >
            Hora</label
          >
          <vue-timepicker
            id="timepicker"
            v-model="reserva.hora"
            :minute-interval="10"
            input-width="100%"
            format="HH:mm"
            close-on-complete
            placeholder="Hora"
            @change="validateHora"
          ></vue-timepicker>
          <span v-if="errorMessage" style="color: red; font-size: 12px">{{
            errorMessage
          }}</span>

          <v-text-field
            v-model.number="reserva.pax"
            label="PAX"
            :rules="Rules.PAX"
            required
          ></v-text-field>
          <v-autocomplete
            :items="areas"
            v-model="areaSelected"
            label="Area"
            item-text="Nombre"
            item-value="id"
          ></v-autocomplete>
          <v-autocomplete
            :items="comp_contenderores"
            v-model="reserva.mesa"
            @change="indexMapa++"
            label="Mesa"
            item-text="Nombre"
            return-object
          >
            <template v-slot:selection="data">
              <v-chip
                v-bind="data.attrs"
                :input-value="data.selected"
                :color="
                  reservated(data.item)
                    ? 'rgba(36, 92, 181)'
                    : data.item.Estado.E == 1
                    ? 'success'
                    : 'primary'
                "
                text-color="white"
              >
                {{ data.item.Nombre }} -
                {{ data.item.Estado.E == 1 ? "Abierto" : "Cerrado" }}
              </v-chip>
            </template>
            <template v-slot:item="data">
              <v-list-item-content>
                <v-chip
                  large
                  :color="
                    reservated(data.item)
                      ? 'rgba(181, 36, 167)'
                      : data.item.Estado.E == 1
                      ? 'success'
                      : 'primary'
                  "
                  text-color="white"
                  :class="reservated(data.item) ? 'dark' : ''"
                >
                  {{ data.item.Nombre }} -
                  {{ data.item.Estado.E == 1 ? "Abierto" : "Cerrado" }}
                  {{
                    data.item.Estado.E == 1
                      ? "|| Mesero:" + data.item.Estado.Mesero.Nom
                      : ""
                  }}
                </v-chip>
              </v-list-item-content>
            </template>
          </v-autocomplete>
          <v-text-field
            v-model="reserva.telefono"
            v-mask="'(###) ###-####'"
            :rules="Rules.telefono"
            label="Teléfono"
          ></v-text-field>
          <v-textarea v-model="reserva.notas" label="Notas"></v-textarea>
          <v-btn :loading="loader" @click="submitForm()" color="primary">{{
            edit ? "Editar Reserva" : "Agregar Reserva"
          }}</v-btn>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from "moment";
import floorRestaurant from "./floorRestaurant.vue";


// The *.vue file with CSS included
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";

export default {
  name: "MesaForm",
  components: {
    floorRestaurant,
    VueTimepicker,
  },
  props: [
    "edit",
    "dataEdit",
    "getAybContenedores",
    "contendeoresValidos",
    "areas",
    "AreasData",
    "reservations",
    "Departamento",
  ],
  data() {
    return {
      Rules: {
        Nombres: [(value) => !!value || "El nombre es obligatorio"],
        fecha: [(value) => !!value || "La fecha es obligatoria"],
        Hora: [
          (value) => !!value || "La hora es obligatoria",
          (value) => this.validarHora(value) || "Ingrese una hora válida",
        ],
        PAX: [
          (value) => !!value || "Pax necesario",
          (value) => typeof value == "number" || "Ingrese un número válido",
        ],
        telefono: [
          (value) =>
            !value ||
            value.length === 14 ||
            value.length === 10 ||
            "Ingrese un número de teléfono válido",
        ],
      },
      reserva: {
        id: null,
        nombre: "",
        fecha: null,
        hora: "",
        pax: "",
        mesa: null,
        telefono: null,
        notas: null,
      },
      areaSelected: "",
      fromDateMenu: false,
      loader: false,
      indexMapa: 1,

      today: moment().format("YYYY-MM-DD"),

      errorMessage: "",
    };
  },
  methods: {
    validateHora(hora) {
      // Expresión regular para validar formato HH:mm (24 horas)
      const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
      return timeRegex.test(hora);
    },
    triggerBokingTable(contenedor) {
      this.areaSelected = "";
      const isReservated = this.reservated(
        this.$pgsHelper.getById(
          this.comp_contenderores,
          "id",
          contenedor.Contenedor.Id
        )
      );
      if (!isReservated) {
        this.reserva.mesa = this.$pgsHelper.getById(
          this.comp_contenderores,
          "id",
          contenedor.Contenedor.Id
        );
        this.areaSelected = this.$pgsHelper.getById(
          this.areas,
          "id",
          this.reserva.mesa.Area
        ).id;
        this.indexMapa++;
      }
    },

    reservated(item) {
      const reservasConMesa = this.reservations
        .filter((reserva) => reserva.ms)
        .map((reserva) => ({ id: reserva.ms.id, fr: reserva.fr }));

      const res = this.$pgsHelper.getById(reservasConMesa, "id", item.id);
      if (res) {
        const reservaFecha = moment(res.fr, "YYYY-MM-DD");
        const itemFecha = moment(this.reserva.fecha, "YYYY-MM-DD");
        const boolFecha = reservaFecha.isSame(itemFecha, "day");

        return boolFecha;
      }
      return false;
    },
    validarHora(value) {
      return moment(value, "HH:mm", true).isValid();
    },
    selectDate(arg) {
      this.input_date = moment(arg);
    },
    async submitForm() {
      const submitHora =
        this.reserva.hora && this.validateHora(this.reserva.hora)
          ? true
          : false;

      this.errorMessage = !submitHora ? "Ingrese una hora válida" : "";
      // Si no hay errores, limpiar el mensaje y continuar

      if (this.$refs.mesaForm.validate() && submitHora) {
        const fechaHoraConcatenada =
          this.reserva.fecha + "_" + this.reserva.hora + ":00";

        let func = this.edit
          ? "AYB-Reservas-updateReserva"
          : "AYB-Reservas-createReserva";
        const successText = this.edit
          ? "Reserva actualizada"
          : "Reserva añadida";
        const errorText = this.edit
          ? " actualizando reserva"
          : " añadiendo reserva";
        this.loader = true;

        let nm = null;
        if (this.reserva.mesa) {
          nm = this.reserva.mesa.Nombre
            ? this.reserva.mesa.Nombre
            : this.reserva.mesa.nm;
        }
        let datos = {
          cn: this.reserva.nombre,
          fr: fechaHoraConcatenada,
          px: Number(this.reserva.pax),
          ms: this.reserva.mesa
            ? {
                id: this.reserva.mesa.id ? this.reserva.mesa.id : null,
                nm: nm,
              }
            : null,
          tl: this.reserva.telefono ? this.reserva.telefono : null,
          nt: this.reserva.notas ? this.reserva.notas : null,
          et: "reservado",
          tenant: this.$store.getters.getFirebaseApp.tenant,
          dp: this.Departamento,
        };
        if (this.reserva.id) {
          datos.id = this.reserva.id;
        }
        await this.$store.getters.getFirebaseApp.fba
          .call(func, datos)
          .then((result) => {
            if (result.data.ok) {
              this.loader = false;
              this.$emit("reloadCloseReserva");
              this.$swal({
                title: successText,
                text: "La operación se realizó correctamente",
                icon: "success",
              });
            } else {
              this.$swal("Error" + errorText, result.error, "error");
              this.loader = false;
            }
          });
      }
    },
  },
  computed: {
    // ...mapGetters("dataLists", ["getAybAreas"]),
    // areas() {
    //   let Areas = [];

    //   Areas = this.getAybAreas;

    //   Areas.forEach((area) => {
    //     this.getAybMapas.forEach((mapa) => {
    //       if (mapa.Area == area.id) {
    //         mapa.Mapa.forEach((item) => {
    //           let contenedor = this.$pgsHelper.getById(
    //             this.getAybContenedores,
    //             "id",
    //             item.id
    //           );
    //           if (contenedor) {
    //             if (contenedor.Estado.E == 1) {
    //               item.Open = true;
    //             } else {
    //               item.Open = false;
    //             }
    //           }
    //           item.contenedor = contenedor;
    //         });
    //         area.Mapa = mapa;
    //       }
    //     });
    //   });

    //   return Areas;
    // },
    fromDateDisp() {
      return this.reserva.fecha;
    },
    comp_contenderores() {
      let data = this.getAybContenedores;

      let contenedor = [];
      data.forEach((cont) => {
        if (this.areaSelected != "") {
          if (this.areaSelected == cont.Area) {
            if (this.contendeoresValidos[cont.id]) {
              contenedor.push(cont);
            }
          }
        } else {
          if (this.contendeoresValidos[cont.id]) {
            contenedor.push(cont);
          }
        }
      });
      return contenedor;
    },
  },
  mounted() {
    this.reserva.fecha = moment().format("YYYY-MM-DD");
    if (this.edit) {
      this.reserva.nombre = this.dataEdit.cn;
      this.reserva.fecha = this.dataEdit.fr.split("_")[0];
      this.reserva.hora = this.dataEdit.hora;
      this.reserva.pax = this.dataEdit.px;
      if(this.dataEdit.ms){
        let exist = this.$pgsHelper.getById(this.comp_contenderores,"id",this.dataEdit.ms.id)
        if(exist){
            this.reserva.mesa = exist;
        }
      }
     
      this.reserva.telefono = this.dataEdit.tl ? this.dataEdit.tl : "";
      this.reserva.notas = this.dataEdit.nt ? this.dataEdit.nt : "";
      this.reserva.id = this.dataEdit.id ? this.dataEdit.id : null;
    }
  },
};
</script>
